import React, { useState } from 'react'
import { FlexboxGrid, IconButton, Popover, Whisper } from 'rsuite';
import { AppSettingsActivators, AppSettings_0, AppSettings_1, AppSettings_2 } from './settings';
import CloseIcon from '@rsuite/icons/Close';
import { ComponentFactory } from '../../Components/ComponentFactory';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { recalcValues, selectConfigState, updateField } from '../calculator/calculatorSlice';
import ToolsIcon from '@rsuite/icons/Tools';
import { updateModal } from '../../Components/Modal/ModalSlice';
import './styles.scss'
import { MdOutlineSettings } from 'react-icons/md';
export const Settings = () => {
    const state = useAppSelector(selectConfigState);
    const dispatch = useAppDispatch();
    const handleChange = (val: any, id: string, valueID?: string) => {
        dispatch(updateField({ val, id, valueID }))
        dispatch(recalcValues())
    }
    const handleOpenModals = (clickActionID: string) => {
        const commonSettings = {
            open: true,
            submitBtnTitle: "Save"
        }
        const transSettings = {
            headerTitle: "Transceiver Settings",
            content: "TransceiverModalContent"
        }
        const splitterSettings = {
            headerTitle: "Splitter Settings",
            content: "SplitterModalContent"
        }
        switch (clickActionID) {
            case "transceiver_settings":
                dispatch(updateModal({
                    ...commonSettings,
                    ...transSettings
                }))
                break;
            case "splitter_settings":
                dispatch(updateModal({
                    ...commonSettings,
                    ...splitterSettings
                }))
                break;
            default:
                break;
        }
        setWhisperOpen(!whisperOpen)
    }
    const [whisperOpen, setWhisperOpen]: any = useState(false)
    const speaker = <Popover 
    //style={{top: 2}}
        title={<div className="popover-settings-title">
            <div>Settings</div>
            <CloseIcon 
                className="close-settings-popup-btn" 
                onClick={() => setWhisperOpen(!whisperOpen)}
            />
        </div>}
        >
        {AppSettings_0.rows.map((component: any) => {
            return <FlexboxGrid className="popover-grid" justify="start" align="middle" key={component.clickActionID}>
                <FlexboxGrid.Item colspan={3}>{component.imageSettings ? <ComponentFactory component={component.imageSettings} /> : <></>}</FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={10}><strong style={{cursor: "pointer"}} onClick={() => handleOpenModals(component.clickActionID)}>{component.name}</strong></FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={11}>
                    <div className='btn-right'>
                        <IconButton
                            icon={<ToolsIcon />}
                            appearance="primary"
                            size="xs"
                            onClick={() => handleOpenModals(component.clickActionID)}
                        />
                    </div>
                </FlexboxGrid.Item>
            </FlexboxGrid>
        })}
        {AppSettingsActivators.rows.map((component: any) => {
            return <FlexboxGrid className="popover-grid" justify="start" align="middle" key={component.id}>
                <FlexboxGrid.Item colspan={3}>{component.imageSettings ? <ComponentFactory component={component.imageSettings} /> : <></>}</FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={10}><strong style={{cursor: "pointer"}} onClick={() => handleOpenModals(component.clickActionID)}>{component.name}</strong></FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={11} className="config_section">
                    <div className='btn-right'>
                        <ComponentFactory
                            component={component}
                            allState={state}
                            componentState={state[component.id]}
                            onChange={(val: any) => handleChange(val, component.id)}
                        />
                    </div>
                </FlexboxGrid.Item>
            </FlexboxGrid>
        })}
        <hr />
        {AppSettings_1.rows.map((component: any) => {
            return <FlexboxGrid className="popover-grid" justify="start" align="middle" key={component.id}>
                <FlexboxGrid.Item colspan={3}>{component.imageSettings ? <ComponentFactory component={component.imageSettings} /> : <></>}</FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={10}><strong>{component.name}</strong></FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={11} className="config_section">
                    <ComponentFactory
                        component={component}
                        allState={state}
                        componentState={state[component.id]}
                        onChange={(val: any) => handleChange(val, component.id, component.valueID)}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>
        })}
        <hr />
        {AppSettings_2.rows.map((component: any) => {
            return <FlexboxGrid className="popover-grid" justify="start" align="middle" key={component.id}>
                <FlexboxGrid.Item colspan={3}>{component.imageSettings ? <ComponentFactory component={component.imageSettings} /> : <></>}</FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={10}><strong>{component.name}</strong></FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={11} className="config_section">
                    <ComponentFactory
                        component={component}
                        allState={state}
                        componentState={state[component.id]}
                        onChange={(val: any) => handleChange(val, component.id, component.valueID)}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>
        })}
    </Popover>
    return (
        <Whisper
            open={whisperOpen}
            controlId="settings-popover"
            trigger="click"
            placement="leftStart"
            speaker={speaker}
            onClick={() => setWhisperOpen(!whisperOpen)}
        >
            <IconButton
                className="rs-btn-cambium rs-btn-cambium-icon"
                icon={<MdOutlineSettings size={22}/>}
            >
                Settings
            </IconButton>
        </Whisper>
    );
}
